import React from 'react';
import ApplicationIcon from '../../../pages/LibraryPage/v2/components/ApplicationIcon';
import Button from '@raydiant/raydial/components/Button';
import cn from 'classnames';

interface LibraryTreeV2ItemProps {
  iconUrl: string;
  label: string;
  onClick: () => void;
  showButton?: boolean;
  onButtonClick?: () => void;
  buttonLabel?: string;
  isDisabled?: boolean;
}

const LibraryTreeV2Item = ({
  iconUrl,
  label,
  onClick,
  showButton = false,
  onButtonClick,
  buttonLabel,
  isDisabled = false,
}: LibraryTreeV2ItemProps) => {
  return (
    <div
      className={cn(
        'flex cursor-pointer items-center h-12 px-4 gap-2 rounded-2xl hover:bg-blue-50',
        showButton && 'bg-blue-50 pr-1',
        isDisabled && 'opacity-50 hover:bg-white cursor-default',
      )}
      onClick={onClick}
    >
      <ApplicationIcon url={iconUrl} />
      <div className="flex-1 truncate text-lg font-regular text-black p-2.5">
        {label}
      </div>
      {showButton && (
        <Button
          variant="secondary"
          className="px-6 py-3 min-w-24 w-24 min-h-10 h-10"
          onPress={onButtonClick ? onButtonClick : () => {}}
        >
          {buttonLabel}
        </Button>
      )}
    </div>
  );
};

export default LibraryTreeV2Item;
